export default "__VITE_ASSET__DD738UBr__"